function Pagination({ currentPage , totalPages , goToPage , visible } ) {
    const pageNumbers = [];
    let maxVisible = 5;
    if ( visible ) {
        maxVisible = parseInt( visible );
    }

    if ( totalPages <= maxVisible ) {
        for ( let i = 1; i <= totalPages; i++ ) {
            pageNumbers.push( i );
        }
    } else {
        let start = Math.max( currentPage - 2, 1 );
        let end = Math.min( start + maxVisible - 1, totalPages );

        start = Math.max( end - maxVisible + 1, 1 );

        for ( let i = start; i <= end; i++ ) {
            pageNumbers.push(i);
        }
    }

    return (
        <div className="pagination">
            <button
                onClick={() => goToPage(currentPage - 1)}
                disabled={currentPage === 1}
            >
                Prev
            </button>

            {pageNumbers[0] > 1 && (
                <>
                    <button className="numbers" onClick={() => goToPage(1)}>1</button>
                    {pageNumbers[0] > 2 && <span className="ellipsis">...</span>}
                </>
            )}

            {pageNumbers.map((page) => (
                <button
                    key={page}
                    onClick={() => goToPage(page)}
                    className={page === currentPage ? "numbers active" : "numbers"}
                >
                    {page}
                </button>
            ))}
        
            {pageNumbers[pageNumbers.length - 1] < totalPages && (
                <>
                    {pageNumbers[pageNumbers.length - 1] < totalPages - 1 && (
                        <span className="ellipsis">...</span>
                    )}
                    <button className="numbers" onClick={() => goToPage(totalPages)}>{totalPages}</button>
                </>
            )}

            <button
                onClick={() => goToPage(currentPage + 1)}
                disabled={currentPage >= totalPages}
            >
                Next
            </button>
        </div>
    );
}

export default Pagination;